import { createContext, Dispatch, SetStateAction, useContext } from "react";

export interface TokenContextInterface {
  accessToken: string | null;
  setAccessToken: Dispatch<SetStateAction<string>>;
}

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 */
const createTokenContext = <A extends object | null>() => {
  const ctx = createContext<A | undefined>(undefined);
  const useUserCtx = () => {
    const c = useContext(ctx);
    if (c === undefined) {
      throw new Error("useTokenCtx must be inside a Provider with a value");
    }
    return c;
  };
  return [useUserCtx, ctx] as const;
};

export const [useTokenContext, TokenContext] =
  createTokenContext<TokenContextInterface>();

